import { serviceAgreementApi } from 'api';

export const closeServiceAgreementsLaterDateApi = async (
  brUid: string,
  serviceAgreementUidList: string[],
  closeDate: Date,
) => {
  const idList = serviceAgreementUidList;

  const response = await serviceAgreementApi.closeServiceAgreementRaw({
    brUid,
    closureDate: closeDate,
    serviceAgreementsClosingRequest: { idList },
  });

  return { status: response.raw.status };
};
